module.exports = __webpack_public_path__ + "img/turbo_off.b86a1ec7.svg";